import { render, staticRenderFns } from "./VMInput.vue?vue&type=template&id=7573223f&scoped=true&lang=pug&"
import script from "./VMInput.vue?vue&type=script&lang=js&"
export * from "./VMInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7573223f",
  null
  
)

export default component.exports